import { PostGeoLocationRequest } from '../../model';
import { HttpClient, ApiResponse } from '@remodeling/base';

export class PostGeoLocationGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: PostGeoLocationRequest) {
    return await this.httpClient.request<ApiResponse<{}>>({
      method: 'POST',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/shop-service/api/v1/shops/geoLocation`,
      body: req,
    });
  }
}
